/** Query param used by the Outlook add-in login redirect flow (legacy Angular parity). */
export const OUTLOOK_ADDIN_FROM = 'outlook-addin';

export function isOutlookAddinSigninFlow(searchParams: {
  get: (key: string) => string | null;
}): boolean {
  return searchParams.get('from') === OUTLOOK_ADDIN_FROM;
}

/**
 * Returns the path + query to return control to the add-in after web sign-in
 * (see outlook-addin `login.tsx` / `taskpane.tsx`).
 */
export function buildOutlookAddinLoginUrl(searchParams: {
  get: (key: string) => string | null;
}): string {
  const params = ['title', 'start_time', 'end_time']
    .map((key) => {
      const val = searchParams.get(key);
      return `${key}=${encodeURIComponent(val || '')}`;
    })
    .join('&');

  return `/outlook-addin/login.html?${params}`;
}
